// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".q-radio__bg path{color:#ed885c!important}.error-message{color:#c10015;transition:all .3s ease-in-out;font-size:12px}@media (max-width:500px){.form-button__second{width:60%!important}.label-dob,.label-issue{display:block!important}.step-two__title{margin-top:30px}.step-two__title,.title-step__two{font-size:16px;margin-bottom:20px}.anketa-wrap{padding:20px 10px!important}}", ""]);
// Exports
module.exports = exports;
